import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description?: string;
  path?: string;
  keywords?: string;    // Gezielte Schlagworte für diese Seite
  image?: string;       // Spezielles Vorschaubild
  type?: 'website' | 'software';
}

export function SEO({ 
  title, 
  description = 'Seriöse Lifestyle-Apps für Paare & Swinger – Diskret & Sicher von JL-Software', 
  path = '',
  keywords = 'Paar-App, Swinger Lifestyle, Erotik-Spiele, LustDuell, Diskrete Software Paare',
  image = 'https://jls-software.de/og-image.jpg',
  type = 'website'
}: SEOProps) {
  const fullTitle = `${title} | JL-Software`;
  const url = `https://jls-software.de${path}`;
  
  // Strukturierte Daten: Sagt Google, dass dies eine Software-Firma ist
  const schemaOrg = {
    "@context": "https://schema.org",
    "@type": type === 'software' ? "SoftwareApplication" : "Organization",
    "name": fullTitle,
    "description": description,
    "url": url,
    "applicationCategory": "LifestyleApplication",
    "operatingSystem": "Android",
    "author": {
      "@type": "Person",
      "name": "Joachim Leiskau"
    },
    "offers": {
      "@type": "Offer",
      "price": "0.00", // Oder dynamisch anpassen
      "priceCurrency": "EUR"
    }
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Entscheidend für die Nische: Einstufung für Google Filter */}
      <meta name="rating" content="adult" />

      {/* Social Media Optimierung */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* JSON-LD für Google Bot */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrg)}
      </script>
    </Helmet>
  );
}